<template>
  <div class="componentRoot">
    <ButtonRowVue class="mb-2">
      <template v-slot:leftSide>
        <v-col v-if="userData" :cols="searchBarCols">
          <v-card flat style="display: flex; align-items: center" class="pl-6">
            <v-tooltip :text="$t('basics.activePatient')" v-if="userData.active_patient">
              <template v-slot:activator="{ props }">
                <span v-bind="props">
                  <v-icon class="mr-2">mdi-shield-account</v-icon>
                </span>
              </template>
            </v-tooltip>
            <h2>{{ userData.full_name }}</h2>
          </v-card>
        </v-col>
      </template>
      <v-col cols="auto" class="pl-0" v-if="hasNewEvent && canPost">
        <v-tooltip :text="$t('messages.createNew')">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" @click="sendNewEvent()" class="primaryButton squareButton" flat><v-icon
                size="x-large">mdi-plus</v-icon></v-btn>
          </template>
        </v-tooltip>
      </v-col>
    </ButtonRowVue>

    <RouterView :userData="userData" :eventNew="eventNew" />
  </div>
</template>

<script>
import UserDetailVue from "./details/Overview.vue";

export default {
  data() {
    return {
      userData: undefined,

      eventNew: 0,
    };
  },
  components: {
    UserDetailVue,
  },

  watch: {
    "$route.params.userID"() {
      window.location.reload()
    }
  },

  computed: {
    canPost() {
      if (
        this.$route.path.includes("qualifications") &&
        this.$checkFunctionPermission(["qualification_post_detail"])
      ) {
        return true;
      }

      if (
        this.$route.path.includes("salary") &&
        this.$checkFunctionPermission(["salary_post_detail"])
      ) {
        return true;
      }

      if (
        this.$route.path.includes("traeger") &&
        this.$checkFunctionPermission(["add_traeger_to_user"])
      ) {
        return true;
      }

      return false;
    },
    hasNewEvent() {
      return (
        this.$route.path.includes("qualifications") ||
        this.$route.path.includes("salary") ||
        this.$route.path.includes("traeger")
      );
    },
    traegerView() {
      if (this.$route.path.includes("traeger/users")) {
        return true
      }

      return false
    },

    searchBarCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
  },

  methods: {
    sendNewEvent() {
      this.eventNew++;
    },
    fetchData() {
      let url = "user/users/"

      let userID = this.$route.params.userID

      if(!userID){
        userID = this.$store.state.id
      }

      this.axios
        .get(this.axios.defaults.baseURL + url + userID)
        .then((resp) => {
          this.userData = resp.data;
          this.$store.dispatch("setActiveElem", {
            userID: resp.data.first_name + " " + resp.data.last_name,
          });

          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("refreshNav"));
          }, 200);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
